import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { MainRouter } from './app/router'
import { ToastContainer } from 'react-toastify'
import { useUser } from '@/store'
import { VersionBadge } from './components/VersionBadge'

import 'react-toastify/dist/ReactToastify.css'

export function App() {
  const initFromStorage = useUser((state) => state.initFromStorage)

  useEffect(() => {
    initFromStorage()
  }, [initFromStorage])

  return (
    <main className='dawn bg-background text-foreground min-h-screen'>
      <BrowserRouter>
        <MainRouter />
      </BrowserRouter>
      <ToastContainer />
      <VersionBadge />
    </main>
  )
}
